/**
 * Enum dos Núcleos de produto (PLM)
 */

export enum EnumNucleoPLM {
  Desenvolvimento = 1,
  GoToMarket = 2,
  Desempenho = 3,
}

/** Descrições para cada Nucleo */
export const NUCLEO_PLM_DESCRIPTIONS: Record<EnumNucleoPLM, string> = {
  [EnumNucleoPLM.Desenvolvimento]: 'Núcleo de desenvolvimento de produtos',
  [EnumNucleoPLM.GoToMarket]: 'Núcleo de Go-To-Market de produtos',
  [EnumNucleoPLM.Desempenho]: 'Núcleo de desempenho de produtos',
};
